import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Button, Breadcrumbs, Input } from '../../../components/UI/ComponentsUI';
import { translate, showMessageToastCustom } from '../../../utils/util';
import { validateInputsRequired, onValueChange } from '../../../utils/handleChangeHooks';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import ModalUploadQmePartNumber from './ModalUploadQmePartNumber';

const QmePartNumberInsert = (props) => {
    const update = props.location?.state?.update;
    const [openModal, setOpenModal] = useState(false);
    const [qmePartNumber, setqmePartNumber] =
        useState(props.location?.state?.update && props.qmePartNumber ?
            props.qmePartNumber :
            {
                partNumberCode: "",
                qme: null
            });


    const onChange = (event) => {
        onValueChange(event, qmePartNumber, setqmePartNumber);
    };


    const onConfirm = () => {
        if (validateInputsRequired("formqmePartNumber")) {
            if (update) {

                props.updateqmePartNumber(qmePartNumber, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-update', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        showMessageToastCustom(translate('general.info'), translate('sucess-to-update', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        props.history.go(-1);
                    }
                });
            } else {
                props.insertqmePartNumber(qmePartNumber, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-include', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        showMessageToastCustom(translate('general.info'), translate('sucess-to-include', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        props.history.go(-1);
                    }
                });
            }
        }
    };

    const title = { icon: "mdi mdi-clipboard-check-outline", label: translate('physical-confirmation:label-qmePartNumber') };
    const subtitles = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, { label: update ? translate('menu.update', 'configuration') : translate('menu.insert', 'configuration') }]
        return subtitlesItems;
    }

    return (
        <div>
            <Breadcrumbs id="qmePartNumberinsert" title={title} subtitles={subtitles()} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <form id="formqmePartNumber" className="col s12">
                                <div className="row" style={{ padding: '10px' }}>
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            id="partNumberCode"
                                            name='partNumberCode'
                                            label={translate('part-number', 'physical-confirmation')}
                                            type="text"
                                            value={qmePartNumber?.partNumberCode || ''}
                                            onChange={onChange}
                                            required
                                        />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            id="qme"
                                            name='qme'
                                            label={translate('qme', 'physical-confirmation')}
                                            type="text"
                                            value={qmePartNumber?.qme || ''}
                                            onChange={onChange}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="input-field no-padding  col s1">
                                    <button
                                        className="btn-floating btn-Small btn-principal waves-effect waves-light"
                                        type="button"
                                        onClick={() => setOpenModal(true)}>
                                        <i className="Small material-icons">cloud_upload</i>
                                    </button>
                                </div>
                            </form>
                            <div className="row" style={{ paddingTop: '10px' }}>
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalUploadQmePartNumber
                open={openModal}
                id="ModalUploadPartnumbers"
                onCancel={() => setOpenModal(false)}
                onClose={() => setOpenModal(false)}
                onConfirm={() => setOpenModal(false)}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        qmePartNumber: state.physicalConfirmationReducer.qmePartNumber
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        insertqmePartNumber: (qmePartNumber, callback) => {
            dispatch(PhysicalConfirmationService.insertQmePartNumber(qmePartNumber, callback));
        },
        updateqmePartNumber: (qmePartNumber, callback) => {
            dispatch(PhysicalConfirmationService.updateQmePartNumber(qmePartNumber, callback));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(QmePartNumberInsert));